if ( typeof ModalBox !== 'function' ) {

  class ModalBox extends HTMLElement {

    constructor() {

      window.inertElems = document.querySelectorAll('[data-js-inert]');

      super();
      this.o = {
        ...{
          show: 10,
          showOnPageOffset: -1,
          frequency: "day",
          enabled: true,
          showOnce: true,
          closeByKey: true,
          disableScroll: true,
          enableClose: false,
          type: false,
          blockTabNavigation: true,
          openedModalBodyClass: "modal-opened",
        },
        ...JSON.parse(this.dataset.options),
      };

			if ( this.o.type == 'cookies' ) {
				
				this.o.enabled = false;

				const showBanner = () => {
					this.o.enabled = true;
					this.show();
				}
			
					const initCookieBanner = () => {
						const consentBridge = window.yojoConsentBridge;
						const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
						const hasShopifyConsent = () => {
							if ( ! customerPrivacy || typeof customerPrivacy.currentVisitorConsent !== 'function' ) {
								return false;
							}

							const consent = customerPrivacy.currentVisitorConsent() || {};
							return ['analytics', 'marketing', 'preferences', 'sale_of_data'].some(key => {
								const value = consent[key];
								return value !== '' && value !== null && typeof value !== 'undefined';
							});
						};
						const hasStoredConsent = () => {
							if ( consentBridge && typeof consentBridge.hasStoredConsent === 'function' ) {
								return consentBridge.hasStoredConsent();
							}

							try {
								return !! localStorage.getItem('yojo_cookie_consent');
							} catch ( error ) {
								return false;
							}
						};
						let shouldShowBanner = ! hasShopifyConsent() && ! hasStoredConsent();

						if ( consentBridge && typeof consentBridge.syncFromShopify === 'function' ) {
							consentBridge.syncFromShopify();
						}

					if ( consentBridge && typeof consentBridge.hydrateConsentInputs === 'function' ) {
						consentBridge.hydrateConsentInputs(this);
					}

						if ( customerPrivacy && typeof customerPrivacy.shouldShowBanner === 'function' ) {
							shouldShowBanner = customerPrivacy.shouldShowBanner() || shouldShowBanner;
						}

						if ( shouldShowBanner ) {
							showBanner();
						}
				}

				if ( window.Shopify && typeof window.Shopify.loadFeatures === 'function' ) {
					window.Shopify.loadFeatures(
						[
							{
								name: 'consent-tracking-api',
								version: '0.1',
							},
						],
						error => {
							if ( error ) {
								console.error('Failed to load Shopify consent tracking API', error);
								return;
							}
							initCookieBanner();
						}
					);
				} else {
					initCookieBanner();
				}
			}

      this._scrollTriggered = false; // To track if scroll condition has been met

      this.addEventListener('open', () => {
        if ( this.o.type == 'cookies' ) {
          this.o.enabled = true;
        }
        this.show();
      });

      if ( this.o.enabled ) {
        this._modalKey = `modal-${document.location.hostname}-${this.id}`;
        try {
          this._modalStorage = !localStorage.getItem(this._modalKey)
            ? "empty"
            : JSON.parse(localStorage.getItem(this._modalKey));
        } catch(e) {
          this._modalStorage = "empty";
        }
        if (this.querySelector("[data-content]")) {
          // data-content-hash, when present, is a variant-independent digest of
          // the modal's configured copy. Sections that render different copy per
          // visitor state (e.g. exit intent's empty-cart vs cart-recovery text)
          // must supply it, otherwise every state flip looks like a copy edit
          // and re-arms the modal past its frequency window.
          const contentElm = this.querySelector("[data-content]");
          this._modalText = contentElm.dataset.contentHash || contentElm.textContent;
        }

        const timeNow = new Date().getTime();
        const inBetween = Math.round(
          (timeNow - this._modalStorage['shown']) / 1000
        );

        let showModal = false;

        if (
          this._modalStorage == 'empty' ||
          (this.o.frequency == 'day' && inBetween > 86400) ||
          (this.o.frequency == 'week' && inBetween > 604800) ||
          (this.o.frequency == 'month' && inBetween > 2419200) ||
          this._modalStorage['content'] != this._modalText
        ) {
          showModal = true;
        }

        if ( showModal ) {

          if ( this.o.type == 'exit_intent_popup' ) {

            let lastMouseY = 0;
            let topOffset = 20;

            // Once the visitor dismisses the popup, the trigger must die for the
            // rest of the pageview — otherwise every trip toward the tab bar
            // re-opens it. hide() removes this listener via _exitIntentHandler.
            this._exitIntentHandler = e => {
              const currentMouseY = e.clientY;
              if (currentMouseY < lastMouseY && currentMouseY < topOffset && ! Shopify.designMode) {
                // Upsell v1 (2026-07-05): never stack on top of an open surface —
                // cart drawer, another modal (age gate) or the newsletter popup.
                const surfaceOpen =
                  document.body.classList.contains('sidebar-opened') ||
                  document.querySelector('modal-box.active, .yojo-popup-overlay.is-active');
                if (!surfaceOpen) {
                  this.show();
                }
              }
              lastMouseY = currentMouseY;
            };
            document.addEventListener('mousemove', this._exitIntentHandler);

          } else if ( this.o.showOnPageOffset > 0 ) {
            this._onScroll = () => {
              const scrollPercent =
                (window.scrollY /
                  (document.documentElement.scrollHeight -
                    window.innerHeight)) *
                100;
              if (
                scrollPercent >= this.o.showOnPageOffset &&
                !this._scrollTriggered
              ) {
                this._scrollTriggered = true;
                setTimeout(() => {
                  this.show();
                }, parseInt(this.o.show * 1000));
                window.removeEventListener('scroll', this._onScroll);
              }
            };
            window.addEventListener('scroll', this._onScroll, {
              passive: true,
            });

          } else {
            setTimeout(() => {
              this.show();
            }, parseInt(this.o.show * 1000));
          }

        }
        this.querySelectorAll('[data-js-close]').forEach(elm =>
          elm.addEventListener('click', () => {
            this.hide(this.o.showOnce);
          })
        );
      } else {
        this.querySelectorAll('[data-js-close]').forEach(elm =>
          elm.addEventListener('click', () => {
            this.hide(this.o.showOnce);
          })
        );
      }

      if ( this.o.enableClose == true ) {
        this.querySelectorAll('[data-js-close]').forEach(elm =>
          elm.addEventListener('click', () => {
            this.hide(this.o.showOnce);
          })
        );
      }

      if ( this.o.closeByKey ) {
        document.addEventListener('keydown', e => {
          if (e.keyCode == 27) {
            if (this.classList.contains('active')) {
              this.hide(this.o.showOnce);
            }
          }
        });
      }
    }

    show(customContent = false) {

      if (customContent && document.querySelector(customContent)) {
        const content = document.querySelector(customContent).innerHTML;
        const modalCommon = document.getElementById('modal-common');
        modalCommon.innerHTML = content;
        if (this.o.enableClose == true) {
          modalCommon.querySelectorAll('[data-js-close]').forEach(elm =>
            elm.addEventListener('click', () => {
              this.hide(this.o.showOnce);
            })
          );
        }
      }

      // Recovery #26 (2026-08-01): a pending hide()'s deferred `display:none`
      // (below) fires unconditionally 500ms after close. If show() is called
      // again inside that window — e.g. Save (data-js-close, closes the
      // modal) immediately followed by the footer "ניהול עוגיות" reopen —
      // the stale timeout still lands and hides the just-reopened modal.
      // Cancel it whenever we (re)open.
      if (this._hideTimeout) {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = null;
      }

      this.setAttribute('style', '');
      setTimeout(() => {
        this.classList.add('active');
        if (this.o.disableScroll) {
          document.body.classList.add(this.o.openedModalBodyClass);
        }
        if (this.o.blockTabNavigation) {
          window.inertElems.forEach(elm =>
            elm.setAttribute('inert', '')
          );
        }
      }, 10);

      setTimeout(() => {
        if (this.querySelector('[data-js-first-focus]')) {
          this.querySelector('[data-js-first-focus]').focus();
        }
      }, 250);
      
    }

    hide(remember = false) {

      // Exit-intent: dismissal is final for this pageview. Killing the trigger
      // here covers every close path (✕, dismiss link, Escape) in one place.
      if (this._exitIntentHandler) {
        document.removeEventListener('mousemove', this._exitIntentHandler);
        this._exitIntentHandler = null;
      }

      this.classList.remove('active');
      document.body.classList.remove(this.o.openedModalBodyClass);
      if (this._hideTimeout) {
        clearTimeout(this._hideTimeout);
      }
      this._hideTimeout = setTimeout(() => {
        // Recovery #26: only commit display:none if we're still the same
        // "closed" request — a reopen in the meantime already cleared this
        // timeout via show(), but guard the class too in case a future
        // caller starts setting display via another path.
        if (!this.classList.contains('active')) {
          this.style.display = 'none';
        }
        this._hideTimeout = null;
      }, 500);
      if (remember && !Shopify.designMode && this._modalKey) {
        localStorage.setItem(
          this._modalKey,
          JSON.stringify({
            shown: new Date().getTime(),
            content: this._modalText,
          })
        );
      }

      window.inertElems.forEach(elm =>
        elm.removeAttribute('inert')
      );
      if (window.lastFocusedElm) {
        setTimeout(() => {
          window.lastFocusedElm.focus();
          window.lastFocusedElm = null;
        }, 100);
      }

    }
  }

  if ( typeof customElements.get('modal-box') == 'undefined' ) {

    // Clone modal elements and move to end of body IF append-top-body
    const originalElements = document.querySelectorAll('modal-box');
    originalElements.forEach((originalElement) => {
      const dataOptions = JSON.parse(originalElement.dataset.options);
      if (dataOptions.appendToBody === true) {
        document.body.appendChild(originalElement);
      }
    });

    customElements.define('modal-box', ModalBox);

  }

  // Shopify events

  document.addEventListener('shopify:section:select', e => {
    if (e.target.classList.contains('mount-popup')) {
      e.target.querySelector('modal-box').style.display = 'block';
      e.target.querySelector('modal-box').show();
    }
  });
  document.addEventListener('shopify:block:select', e => {
    if (e.target.hasAttribute('data-modal-box')) {
      e.target.style.display = 'block';
      e.target.show();
    }
  });
  document.addEventListener('shopify:block:deselect', e => {
    if (e.target.hasAttribute('data-modal-box')) {
      e.target.hide();
    }
  });
  document.addEventListener('shopify:section:deselect', e => {
    if (e.target.classList.contains('mount-popup')) {
      e.target.querySelector('modal-box').hide();
    }
  });
	
}
